import type { RdoPhotoSize } from "@/adapters/api";

export const RDO_PHOTO_SIZE_LABELS: Record<RdoPhotoSize, string> = {
	small: "Pequenas (3 por linha)",
	medium: "Médias (2 por linha)",
	large: "Grandes (1 por linha)",
};

export const RDO_PHOTO_SIZES = Object.keys(
	RDO_PHOTO_SIZE_LABELS,
) as RdoPhotoSize[];

export function isRdoPhotoSize(value: string): value is RdoPhotoSize {
	return Object.hasOwn(RDO_PHOTO_SIZE_LABELS, value);
}
